import { Component, ElementRef, OnInit, Input, ViewChild } from '@angular/core';
import { SetService, JwtService, PageService } from 'ngx-block-core';
import { HttpService } from 'ngx-block-core';
import { FormControlService } from "ngx-block-core";
import { selectSize, iconTheme, eventTypeInput } from "../../../data/data";
import { ActivatedRoute } from '@angular/router';
import { BlockBaseComponent } from "../../../components/block";

const staticSets = {
  eventDatas: null,
  generateDatas: null,
  baseDatas: null,
  formDatas: {
    nzSearchDataType: "string|array",
    nzSearchType: "like"
  },
  otherDatas: null,
}


@Component({
  selector: 'app-sucu04-weiget0010001',
  styleUrls: ['./sucu04-weiget0010001.component.less'],
  templateUrl: './sucu04-weiget0010001.component.html',
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class Sucu04Weiget0010001Component extends BlockBaseComponent {
  constructor(
    public formControlService: FormControlService,
    private activatedRoute: ActivatedRoute,
    public setService: SetService,
    protected pageService: PageService,
    protected jwtService: JwtService,
    protected http: HttpService,
  ) {
    super(setService, pageService, jwtService, http);
  }

  staticSets = staticSets;

  doValueChange(val) {
    console.log("inputchange", val + "]")

    if (this.sets.styles['nzTrim'] && typeof val == "string") {
      //收尾空校验
      var reg = /^[\s　]|[ ]$/gi;
      if (reg.test(val)) {
        this.form.get(this.nzFormGroupData.nzKey).patchValue(val.replace(/(^\s*)|(\s*$)/g, ""));
        return;
      }

    }
    this.hiddendatas_main('change');

    if (val != "" && this.sets.styles['nzFocusMove'] != '' && this.sets.styles['nzFocusMove'] != this.blockid) {
      console.log("move-focus", this.sets.styles['nzFocusMove'])
      try {
        this.setService.events[this.sets.styles['nzFocusMove']].emit({
          type: "focus",
          datas: {}
        });
      } catch (error) {
        console.log("move-focus", error)
      }

    }

    console.log("valueChangesval", val + "]");
    this.formControlService.dataEvent(val, this.nzFormGroupData, this.blockid)
    if (this.needCalculate.used) {
      this.setService.events[this.needCalculate.id].emit({
        type: 'changeCalculateValue',
      });
    }

    if (this.sets.datas.nzFormGetData.nzUsed) {
      console.log("加载表单事件");
      this.formControlService.form_getData(this.setService.pageDatas['form_data_' + this.layoutid], this.setService.pageDatas['form_' + this.layoutid], this.activatedRoute);
    }

    //事件
    this.sets.datas.nzEvents.forEach(element => {
      this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
        switch (element) {
          case 'sendSimpleEvent':
            // this.endEvent.push(element);

            switch (itemEvents['name']) {
              case "search":
                if (val !== null && val !== undefined) {
                  let data = {};
                  if (itemEvents['param1'] === '' || itemEvents['param1'] === null || itemEvents['param1'] === undefined) itemEvents['param1'] = '=';
                  data[itemEvents['param0']] = [
                    {
                      "name": itemEvents['param1'],
                      "type": "",
                      "instruction": "",
                      "value1": val,
                      "value2": ""
                    }
                  ]
                  console.log("jsonsss", JSON.stringify(this.sets.datas.nzEventsDatas[element]), data)
                  if (this.setService.events[itemEvents['blockid']] !== undefined) {
                    this.setService.events[itemEvents['blockid']].emit({
                      type: itemEvents['name'],
                      datas: data,
                      sets: itemEvents['param2']
                    })
                  }

                  // this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], data)
                }

                break;
              case "updateNum":
                this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], {
                  value: val,
                  upField: itemEvents['param0']
                })
                console.log("updateNum", JSON.stringify(this.sets.datas.nzEventsDatas[element]), {
                  value: val,
                  upField: itemEvents['param0']
                })
                break;

              default:
                let senddata = { value: val };
                try {
                  senddata['param0'] = itemEvents['param0'];
                  senddata['param1'] = itemEvents['param1'];
                  senddata['param2'] = itemEvents['param2'];
                } catch (error) {

                }
                console.log("send", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                break;
            }

            break;

          default:
            break;
        }
      });

    });
    //联动

    if (this.sets.datas.nzLinkage.nzUsed) {
      if (!this.sets.datas.nzLinkageData.nzNotNull || (val !== '' && val !== null && val !== undefined)) {
        this.sets.datas.nzLinkage.nzEvents.forEach(element => {
          console.log("element", JSON.stringify(element));
          this.setService.sendEvent(element.blockid, "linkage" + element.type, { value: val })
        });
      }

    }
  }

  @ViewChild('input') input: ElementRef;


  value = "";
  @Input() sets = {
    blockCode: "sucublock21",
    blockId: "",
    blockName: "输入框",
    layoutId: "",
    blockType: 'formBlock',
    blockChildType: '',
    versionCode: 38,
    attributes: ['form', 'nzFormGroupData', 'nzLayout'],
    sets: {
      acl: false
    },
    events: [
      {
        label: "重置",
        value: "reset",
        data: { setParams: ["刷新 : true|false", '只刷新 : true|false', '备用'] }
      },
      {
        label: "可用不可用",
        value: "isable",
        data: {
          setParams: ["不可用值", '可用值', 'disable(强制不可用),enable(强制可用,不可用值不能为空),reset,disablevalue(例:disablevalue,1),enablevalue']
        }
      },
      {
        label: "自动焦点",
        value: "focus",
        data: { setParams: ["延时 : 100 1000"] }
      },
      {
        label: "隐藏",
        value: "pageShow",
        data: {
          setParams: ["隐藏值", '显示值，可不填', '备用']
        }
      },
      {
        label: "联动开关",
        value: "linkageControl",
        data: {
          setParams: ["关闭值", '启用值，可不填', '备用']
        }
      },
      {
        label: "校验检测",
        value: "valid",
        data: {
          setParams: ["备用", '备用', '备用']
        }
      }
    ],

    styles: {
      nzTextColor: "",
      nzSize: "small",
      nzPlaceHolder: "请输入内容",
      nzPassword: false,
      nzHidden: false,
      nzNoSee: false,
      nzDate: false,
      nzLayout: {
        nzLayout1: 0,
        nzLayout2: 8,
        nzLayout3: 0,
        nzLayout4: 16,
        nzAlign: 'left',
        nzMarginBottom: 3,
        nzLineHeight: 1.4,
        nzFontSize: 12,
        nzFocus: true,
        nzFocusType: "input1",
      },
      nzRequired: false,
      nzHasFeedback: true,
      nzReadOnly: false,
      nzReadOnlyLight: false,
      nzIcon: {
        nzIconType: '',
        nzIconTheme: ''
      },
      nzFocus: false,
      nzToLocaleUpperCase: false,
      nzTrim: true,
      nzFocusMove: "",
      nzDebounceTime: 500,
      nzShow: false,
      nzTest: "true",
      nzExpandId: "",
      nzPopover: {
        nzUsed: false,
        nzContent: [],
        nzTrigger: 'click',
        nzButton: false,
        nzButtonType: 'jump',
        nzButtonText: '高级搜索'
      }
    },
    datas: {
      nzHiddendatas: {
        nzNames: [],
        nzSets: {
          "id": 1
        }
      },
      nzSearchDataType: "string|array",
      nzSearchType: "like",
      nzSameTableCalculate: {
        nzUsed: false,
        nzFormula: "",
        nzReplaceValue: [
          // {
          //   name:"@v1",
          //   field:"",
          // }
        ]
      },
      nzFormGetData: {
        nzUsed: false,
      },
      nzLinkage: {
        nzUsed: false,

        nzEvents: [
          // {
          //   blockid:blockid,
          //   type:"value"//value,datasource
          // }
        ],//blockid
      },
      nzLinkageData: {
        nzlinkageClosed: false,
        nzValueSend: false,
        nzLinkageType: "default",//group
        nzDynamicSql: "",
        nzGroupLinkageRule: "",
        nzGroupRules: {
          linkage1: "",
          linkage2: "",
          linkage3: "",
          linkage4: ""
        },
        nzNotNull: false,
        nzSubmit: false
      },
      nzEvents: [

      ],
      nzEventsDatas: {
      },
      nzCloseValue: true,
      nzServiceParam: [],
      nzServiceParamDetail: { "sequ": 1 },
      nzJumpType: "self",
      nzJumpPageType: 0,
      nzJumpPage: "",
      nzJumpMode: "none",
      nzJumpModalTitle: "",
      nzJumpModalWidth: 520,
      nzSenceJson: [],
      nzValueSource: [],
      nzEnterFilter: false
    }
  };

  setData = []

  nzPopoverUsed = false;

  autoUpdate() {

    //vc:5
    //影藏控件
    if (this.sets.versionCode < 5) {
      if (typeof this.sets.styles.nzHidden == "undefined") {
        this.sets.styles.nzHidden = false;
      }
      this.sets.versionCode = 5;
    }

    if (this.sets.versionCode < 6) {

      this.sets.blockCode = "sucublock21";

      this.sets.versionCode = 6;
    }
    if (this.sets.versionCode < 7) {

      this.sets.styles.nzNoSee = false;

      this.sets.versionCode = 7;
    }
    if (this.sets.versionCode < 8) {

      this.sets.datas.nzEvents = [];
      this.sets.datas.nzEventsDatas = {};

      this.sets.versionCode = 8;
    }
    //vc:9
    //附加事件大整改
    if (this.sets.versionCode < 9) {
      for (const key in this.sets.datas.nzEventsDatas) {
        const element = this.sets.datas.nzEventsDatas[key];
        element['dataArray'] = [
          element['datas']
        ];
        element['dataArray'][0]['blockid'] = element['blockid']


      }

      this.sets.versionCode = 9;
    }
    //vc:10
    //联动
    if (this.sets.versionCode < 10) {

      this.sets.datas['nzLinkageData']['nzLinkageType'] = "default";
      this.sets.datas['nzLinkageData']['nzGroupLinkageRule'] = "";
      this.sets.datas['nzLinkageData']['nzGroupRules'] = {
        linkage1: "",
        linkage2: "",
        linkage3: "",
        linkage4: ""
      }
      this.sets.versionCode = 10;
    }


    //12
    if (this.sets.versionCode < 12) {

      this.nzFormGroupData['nzValidators'].forEach(valid => {
        if (valid.nzValidSetType == 'asyncsSql' && typeof valid['nzValidParams']['param1']['res'] == "undefined") {
          valid['nzValidParams']['param1']['res'] = 'none';
        }
      });


      this.sets.versionCode = 12;
    }
    //12
    if (this.sets.versionCode < 13) {

      this.sets.styles['nzFocus'] = false;

      this.sets.versionCode = 13;
    }
    if (this.sets.versionCode < 14) {

      this.sets.styles['nzToLocaleUpperCase'] = false;

      this.sets.versionCode = 14;
    }
    if (this.sets.versionCode < 15) {

      this.sets.styles['nzFocusMove'] = "";

      this.sets.versionCode = 15;
    }
    if (this.sets.versionCode < 19) {


      this.sets.styles['nzShow'] = true;
      this.sets.versionCode = 19;
    }
    if (this.sets.versionCode < 20) {


      this.sets.styles['nzTest'] = "true";
      this.sets.versionCode = 20;
    }
    if (this.sets.versionCode < 21) {


      this.sets.styles['nzTrim'] = true;
      this.sets.versionCode = 21;
    }
    if (this.sets.versionCode < 22) {

      this.sets.styles['nzTest'] = "true";
      this.sets.versionCode = 22;
    }
    if (this.sets.versionCode < 23) {

      this.sets.styles['nzExpandId'] = "";
      this.sets.versionCode = 23;
    }
    if (this.sets.versionCode < 23) {

      this.sets.styles['nzReadOnlyLight'] = false;
      this.sets.versionCode = 23;
    }


    if (this.sets.versionCode < 26) {

      this.sets.datas['nzHiddendatas'] = {
        nzNames: [],
        nzSets: {
          "id": 1
        }
      },
        this.sets.versionCode = 26;
    }

    if (this.sets.versionCode < 27) {

      this.sets.datas['nzLinkageData']['nzlinkageClosed'] = false;
      this.sets.versionCode = 27;
    }
    if (this.sets.versionCode < 30) {

      this.sets.styles['nzPopover'] = {
        nzUsed: false,
        nzContent: [],
        nzTrigger: 'click',
        nzButton: false,
        nzButtonType: 'jump',
        nzButtonText: '高级搜索'
      }
      this.sets.datas['nzJumpType'] = "self";
      this.sets.datas['nzJumpPageType'] = 0;
      this.sets.datas['nzJumpPage'] = "";
      this.sets.datas['nzJumpMode'] = "none";
      this.sets.datas['nzJumpModalTitle'] = "";
      this.sets.datas['nzJumpModalWidth'] = 520;
      this.sets.datas['nzSenceJson'] = [];
      this.sets.datas['nzCloseValue'] = true;
      this.sets.datas['nzServiceParam'] = [];
      this.sets.datas['nzServiceParamDetail'] = { "sequ": 1 }
      this.sets.datas['jumpLog'] = '';
      this.sets.versionCode = 30;
    }
    if (this.sets.versionCode < 31) {

      this.sets.datas['nzValueSource'] = [];
      this.sets.versionCode = 31;
    }
    if (this.sets.versionCode < 32) {

      this.sets.datas.nzLinkageData['nzValueSend'] = false;
      this.sets.versionCode = 32;
    }
    if (this.sets.versionCode < 33) {
      this.sets.datas.nzLinkageData['nzNotNull'] = false;
      this.sets.versionCode = 33;
    }


    if (this.sets.versionCode < 37) {

      this.sets.datas.nzLinkageData['nzSubmit'] = false;
      this.sets.versionCode = 37;
    }
    if (this.sets.versionCode < 38) {

      this.sets['events'] =
        [
          {
            label: "重置",
            value: "reset",
            data: { setParams: ["刷新 : true|false", '只刷新 : true|false', '备用'] }
          },
          {
            label: "可用不可用",
            value: "isable",
            data: {
              setParams: ["不可用值", '可用值', 'disable(强制不可用),enable(强制可用,不可用值不能为空),reset,disablevalue(例:disablevalue,1),enablevalue']
            }
          },
          {
            label: "自动焦点",
            value: "focus",
            data: { setParams: ["延时 : 100 1000"] }
          },
          {
            label: "隐藏",
            value: "pageShow",
            data: {
              setParams: ["隐藏值", '显示值，可不填', '备用']
            }
          },
          {
            label: "联动开关",
            value: "linkageControl",
            data: {
              setParams: ["关闭值", '启用值，可不填', '备用']
            }
          },
          {
            label: "校验检测",
            value: "valid",
            data: {
              setParams: ["备用", '备用', '备用']
            }
          }
        ]
      this.sets.versionCode = 38;
    }




  }
  ngOnInit() {
    super.ngOnInit();
    this.pageService.pageBlockDatas[this.blockid] = {
      nzHiddendatas: {

      }
    }
    this.nzLinkageClosed = this.sets.datas.nzLinkageData.nzlinkageClosed;
    if (this.sets.styles.nzFocus)
      this.nzFormGroupData['nzValue']['nzValueFormat'] = "focus";
    if (this.sets.styles.nzDate) {
      this.nzFormGroupData['nzSearchDataType'] = "date";
    }
    this.nzPopoverUsed = this.sets.styles.nzPopover.nzUsed;
    if (this.sets.datas.nzLinkageData.nzSubmit) {
      this.pageService.pageDatas['LinkEvents' + this.blockid] = this.sets.datas.nzLinkage.nzEvents;
    }
  }

  keydown(event) {
    console.log('keydown-input', event)
    if (this.sets.datas.nzEnterFilter && event.keyCode == 13) return false;
    console.log("do");
  }
  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormDataSource' },
              {
                name: 'nzFormSearchType',
                inputs: {
                  snChange: true,
                  dateFormat: true,
                }
              },
              {
                name: 'switch',
                inputs: { nzText: "日期存储 : ", nzKeys: ['styles', 'nzDate'], nzPopContent: "存到数据库为日期格式" },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzSearchDataType'] = "date";
                    else
                      this.nzFormGroupData['nzSearchDataType'] = "string|array";
                  }
                }
              },
              { name: 'nzLinkage', inputs: { otherSets: ['type', 'sql', 'group', 'close', 'send', 'notNull', 'submit'], nzBlockSets: this.sets } },
              { name: 'nzHiddendatas' },

            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'color',
                inputs: { nzText: "文字颜色 : ", nzKeys: ['styles', 'nzTextColor'] }
              },
              {
                name: 'input',
                inputs: { nzText: "提示文字 : ", nzKeys: ['styles', 'nzPlaceHolder'] }
              },
              {
                name: 'input',
                inputs: { nzText: "前置标签 : ", nzModel: this.nzFormGroupData['nzValue'], nzKeys: ['nzValueBefore'] }
              },
              {
                name: 'input',
                inputs: { nzText: "后置标签 : ", nzModel: this.nzFormGroupData['nzValue'], nzKeys: ['nzValueAfter'] }
              },
              {
                name: 'input',
                inputs: { nzText: "前置图标 : ", nzKeys: ['styles', 'nzIcon', 'nzIconType'], nzPopContent: ['填入type,请参照官方文档:', 'https://ng.ant.design/components/icon/zh'] }
              },
              {
                name: 'radio',
                inputs: { nzText: "前置图标主题:", nzKeys: ['styles', 'nzIcon', 'nzIconTheme'], nzData: iconTheme, },
                outputs: { ngModelChange: () => { if (this.sets.styles.nzIcon.nzIconTheme == '') this.setService.onReLoadbBlock(this.layoutid) } }
              },
              {
                name: 'switch',
                inputs: { nzText: "只读 : ", nzKeys: ['styles', 'nzReadOnly'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.form.get(this.nzFormGroupData.nzKey).disable();
                    else
                      this.form.get(this.nzFormGroupData.nzKey).enable();
                  }
                }
              },
              {
                name: 'switch',
                inputs: { nzText: "校验只读 : ", nzKeys: ['styles', 'nzReadOnlyLight'] },

              },

              {
                name: 'nzLayout'
              },
              {
                name: 'radio',
                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
              },
              {
                name: 'switch',
                inputs: { nzText: "显示必填* : ", nzKeys: ['styles', 'nzRequired'], nzPopContent: ['仅影响样式'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "校验图标 : ", nzKeys: ['styles', 'nzHasFeedback'], nzPopContent: ['校验状态的图标'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "密码样式 : ", nzKeys: ['styles', 'nzPassword'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "隐藏 : ", nzKeys: ['styles', 'nzHidden'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "转大写 : ", nzKeys: ['styles', 'nzToLocaleUpperCase'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "去空格 : ", nzKeys: ['styles', 'nzTrim'] }
              },
              {
                name: 'input',
                inputs: { nzText: "测试 : ", nzKeys: ['styles', 'nzTest',] }
              },

              {
                name: 'switch',
                inputs: { nzText: "表单忽视 : ", nzKeys: ['styles', 'nzNoSee'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzSearchDataType'] = "noSee";
                    else
                      this.nzFormGroupData['nzSearchDataType'] = "string|array";
                  }
                }
              },
              {
                name: 'switch',
                inputs: { nzText: "自动焦点 : ", nzKeys: ['styles', 'nzFocus'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzValue']['nzValueFormat'] = "focus";
                    else
                      this.nzFormGroupData['nzValue']['nzValueFormat'] = "yyyy-mm-dd hh24:mi:ss";
                  }
                }

              },
              {
                name: 'select',
                inputs: { nzText: "焦点转移 : ", nzKeys: ['styles', 'nzFocusMove'], nzData: this.setService.getBlock('*', "*") },
              },
              {
                name: 'number',
                inputs: { nzText: "防抖时间 : ", nzKeys: ['styles', 'nzDebounceTime'] }
              },
              {
                name: 'button',
                inputs: {
                  nzText: ["设置页面id"]
                },
                outputs: {
                  onClick1: () => {
                    this.form.get(this.nzFormGroupData.nzKey).patchValue(this.setService.pageId);
                    this.nzFormGroupData.nzValue.nzValue = this.setService.pageId;
                    this.nzFormGroupData.nzValue.nzDynamic.nzUsed = false;
                    this.nzFormGroupData.nzValue.nzUrl.nzUsed = false;
                    this.nzFormGroupData.nzValue.nzUrl.nzKey = '';
                    this.nzFormGroupData.nzValue.nzKeep = true;
                    this.nzFormGroupData.nzValue.nzKeep = true;
                    this.nzFormGroupData.nzValue.nzFilterAutoValue = true;


                  }
                }
              },
              {
                name: 'select',
                inputs: { nzText: "收展绑定 : ", nzKeys: ['styles', 'nzExpandId'], nzData: [{ value: "", label: '无' }, ...(this.setService.getBlock("formButton", "*"))] },
              },
              {
                name: 'nzPopover',
                inputs: { nzOtherTypes: [{ value: 'enable', label: '可用' }] }
              },

              // nzTrigger
            ]
          },
        ]
      },
      {
        tabName: '表单',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormSet' },
            ]
          }
        ]
      },
      {
        tabName: '高级功能',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzSameTableCalculate' }
            ]
          },
          {
            type: 'styles',
            data: [
              {
                name: 'switch',
                inputs: { nzText: "加载参数 : ", nzKeys: ['datas', 'nzFormGetData', 'nzUsed'], nzPopContent: ['启动加载参数，表单输入值发生变化后会触发表单加载事件'] }
              }
            ]
          },
          {
            type: 'datas',
            data: [
              { name: "nzEvents", inputs: { eventType: eventTypeInput } },
              {
                name: 'switch',
                inputs: { nzText: "回车过滤 : ", nzKeys: ['datas', 'nzEnterFilter'] }
              },
            ]
          },
        ]
      }
    ]
  }


  /**
   * 计算功能初始化
   */
  initCalculate(open = true) {
    if (this.sets.datas.nzSameTableCalculate.nzUsed || open == false) {
      this.sets.datas.nzSameTableCalculate.nzReplaceValue.forEach(element => {

        this.setService.events[element.field].emit({
          type: 'needCalculate',
          datas: {
            used: open,
            id: this.blockid,
            name: element.name
          }
        });
      });
      if (open)
        this.calculateValue()
    }
  }
  /**
   * 计算数值
   */
  calculateValue() {
    let nzFormula = this.sets.datas.nzSameTableCalculate.nzFormula;
    //取值,替换值
    this.sets.datas.nzSameTableCalculate.nzReplaceValue.forEach(element => {
      const value = this.form.get(this.calculate_name_key[element.name]).value;
      nzFormula = nzFormula.replace(new RegExp(element.name, "gm"), value);
    });

    try {
      this.form.get(this.nzFormGroupData.nzKey).patchValue(eval(nzFormula));
    } catch (error) {

    }


  }
  needCalculate = {
    used: false,
    id: "",
    name: ""
  };
  calculate_name_key = {}
  onClick() {
    console.log('onClick', this.form.get(this.nzFormGroupData.nzKey).disabled, this.sets.styles.nzPopover.nzButtonType, this.nzPopoverUsed)

    if (!this.sets.styles['nzPopover']['nzUsed'] && this.sets.styles.nzPopover.nzButtonType === 'jump' && !this.sets.styles['nzPopover']['nzButton']) {
      this.popClick();
    }
  }
  popVisible = false;
  popClick() {
    switch (this.sets.styles.nzPopover.nzButtonType) {
      case 'jump':
        console.log('nzJumpType', this.sets.datas.nzJumpType)
        if (this.sets.datas.nzJumpType === 'pop') {
          if (!this.static) {//配置环境
            console.log('!static')

          } else {
            const dateSets = {
              "type": this.sets.datas.nzJumpType,
              "mode": this.sets.datas.nzJumpMode,
              "nzSenceJson": this.sets.datas.nzSenceJson,
              "pageRoute": this.sets.datas.nzJumpPage,
              "modalTitle": this.sets.datas.nzJumpModalTitle,
              "modalWidth": this.sets.datas.nzJumpModalWidth,
              'acceptBlockId': this.blockid
            }
            let queryParams = {};
            this.sets.datas['nzServiceParam'].forEach(param => {
              queryParams[this.sets.datas['nzServiceParamDetail'][param]['urlName']] = this.pageService.getServiceParam(this.sets.datas['nzServiceParamDetail'][param], this.activatedRoute);
            });
            this.popVisible = false;
            this.pageService.goRouter(dateSets, queryParams, '', this.sets.datas['jumpLog']);
          }

        }
        break;
      case 'enable':
        console.log('onClick', 'enable', this.popVisible, this.form.get(this.nzFormGroupData.nzKey).disabled)

        if (this.form.get(this.nzFormGroupData.nzKey).disabled) {
          this.sets.styles.nzReadOnlyLight = false;
          this.form.get(this.nzFormGroupData.nzKey).enable();
          this.popVisible = false;
        }

        break;

      default:
        break;
    }


  }
  // ngModelChange(value) {

  linkValue = {
    linkage: "",
    linkage2: "",
    linkage3: "",
    linkagek1: ""
  }

  hiddendatas_main(time, get = true, clear = true, err = false) {
    this.sets.datas.nzHiddendatas.nzNames.forEach(paramName => {
      const data = this.sets.datas.nzHiddendatas.nzSets[paramName];
      if (data['getTime'].indexOf(time) >= 0) {
        if (clear) {
          //先清除数据
          if (this.pageService.pageBlockDatas[this.blockid]['nzHiddendatas'][paramName] !== undefined) {
            delete this.pageService.pageBlockDatas[this.blockid]['nzHiddendatas'][paramName]
          }
        }
        if (get) {
          //获取数据
          this.hiddendatas_get(paramName, data)
        }
        if (err) {
          this.pageService.pageBlockDatas[this.blockid]['nzHiddendatas'][paramName] = {
            name: data.name,
            value: "",
            state: 'error',
            msg: data.errorMsg
          }
        }

      }
    });
  }
  hiddendatas_get(paramName, data) {
    switch (data.type) {
      case 'sql':
        this.hiddendatas_sql(paramName, data);
        console.log('hiddendatas_sqldoing...');

        break;

      default:
        break;
    }
  }




  hiddendatas_sql(paramName, set) {
    let sql = set.sql;
    if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) sql = sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
    if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) sql = sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
    if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) sql = sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
    if (typeof this.linkValue.linkagek1 != "undefined") sql = sql.replace(new RegExp("@linkagek1", "gm"), this.linkValue.linkagek1);
    if (typeof this.form.get(this.nzFormGroupData.nzKey).value != "undefined") sql = sql.replace(new RegExp("@currentValue@", "gm"), this.form.get(this.nzFormGroupData.nzKey).value);

    let body = {
      "dynamicSql": this.pageService.replaceParam(this.jwtService.replaceUser(sql), this.layoutid),
      "pageSize": 0,
      "nowPage": 0,
      "paramMap": [],
      "tableSort": [],
      "searchMap": {
      }
    }
    console.log("hiddendatas_sql_body:" + JSON.stringify(body));

    console.log("hiddendatas_sql_body2:" + JSON.stringify(body));

    if (sql.indexOf("@linkage") == -1 && sql.indexOf("@currentValue@") == -1 && body.dynamicSql != "") {
      this.pageService.pageBlockDatas['wait_' + this.blockid] = false;

      this.http.postHttp("/system/dynamicSql", body).subscribe(
        (data: any) => {
          console.log("hiddendatas_sql_data", data)
          if (data.data.list.length > 0) {
            this.pageService.pageBlockDatas[this.blockid]['nzHiddendatas'][paramName] = {
              name: set.name,
              value: data.data.list[0]['VALUE'],
              state: 'success',
              msg: ""
            }
          }
          else {
            this.pageService.pageBlockDatas[this.blockid]['nzHiddendatas'][paramName] = {
              name: set.name,
              value: "",
              state: 'error',
              msg: set.errorMsg
            }
          }
          console.log("hiddendatas_sql_end", this.pageService.pageBlockDatas[this.blockid])
          this.pageService.pageBlockDatas['wait_' + this.blockid] = true;

        },
        (error: any) => {
          this.pageService.pageBlockDatas[this.blockid]['nzHiddendatas'][paramName] = {
            name: set.name,
            value: "",
            state: 'error',
            msg: set.errorMsg
          }
          this.pageService.pageBlockDatas['wait_' + this.blockid] = true;

        })
    }

  }






  linkageValue(value, type) {
    this.linkValue['linkage' + type] = value;
    this.hiddendatas_main('linkage')
    let sql = this.sets.datas.nzLinkageData.nzDynamicSql;

    if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) sql = sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
    if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) sql = sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
    if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) sql = sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
    if (typeof this.linkValue.linkagek1 != "undefined") sql = sql.replace(new RegExp("@linkagek1", "gm"), this.linkValue.linkagek1);
    let body = {
      "dynamicSql": this.pageService.replaceParam(this.jwtService.replaceUser(sql), this.layoutid),
      "pageSize": 0,
      "nowPage": 0,
      "paramMap": [],
      "tableSort": [],
      "searchMap": {
      }
    }
    console.log("body:" + JSON.stringify(body));
    if (sql.indexOf("@linkage") == -1 && body.dynamicSql != "") {
      this.hiddendatas_main('linkageEnd', false);
      this.pageService.pageBlockDatas['wait_' + this.blockid] = false;
      this.http.postHttp("/system/dynamicSql", body).subscribe(
        (data: any) => {
          console.log("dynamicSql:" + JSON.stringify(data));
          if (data.data.list.length > 0) {
            this.form.get(this.nzFormGroupData.nzKey).patchValue(data.data.list[0]['VALUE'])
            if (this.sets.datas.nzLinkageData.nzValueSend) {
              this.setValue({ datas: data.data.list[0] });
            }
            this.hiddendatas_main('linkageEnd', true, false);

          }
          else {
            this.form.get(this.nzFormGroupData.nzKey).patchValue('')
            this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
            this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
            if (this.sets.datas.nzLinkageData.nzValueSend) {
              this.setValue({ datas: {} });
            }
            this.hiddendatas_main('linkageEnd', false, false, true);
          }
          this.pageService.pageBlockDatas['wait_' + this.blockid] = true;
        },
        (err: any) => {
          this.pageService.pageBlockDatas['wait_' + this.blockid] = true;

        }
      )
    } else {
      this.form.get(this.nzFormGroupData.nzKey).patchValue('');
      this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
      this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
    }

  }
  groupLinkAge(value, type) {
    this.linkValue['linkage' + type] = value;
    let valueRule = this.sets.datas.nzLinkageData.nzGroupLinkageRule;
    switch (this.sets.datas.nzLinkageData.nzGroupRules['linkage' + type]) {
      case 'number@':
        let newValue = "";
        for (let index = 0; index < parseInt(this.linkValue['linkage' + type]); index++) {
          newValue = newValue + "@"
        }
        this.linkValue['linkage' + type] = newValue
        break;

      default:
        break;
    }

    if (typeof this.linkValue.linkage != "undefined")
      valueRule = valueRule.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
    if (typeof this.linkValue.linkage2 != "undefined")
      valueRule = valueRule.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
    if (typeof this.linkValue.linkage3 != "undefined")
      valueRule = valueRule.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
    if (typeof this.linkValue.linkagek1 != "undefined")
      valueRule = valueRule.replace(new RegExp("@linkagek1", "gm"), this.linkValue.linkagek1);

    this.form.get(this.nzFormGroupData.nzKey).patchValue(valueRule)
    this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
    this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();

  }
  onChange(value) {
    console.log("onChange", value)
    let flag = false;
    let type = typeof value;
    // if (this.sets.styles['nzTrim']) {
    //   if (type == "string") {
    //     //收尾空校验
    //     var reg = /^[\s　]|[ ]$/gi;
    //     if (reg.test(value)) {
    //       value = value.replace(/(^\s*)|(\s*$)/g, "");
    //       flag = true;
    //     }
    //   }
    // }
    if (this.sets.styles['nzToLocaleUpperCase']) {
      if (type == "string") {
        //小写转大写

        var reg2: RegExp = /[a-z]/;
        if (reg2.test(value)) {
          value = value.toLocaleUpperCase();
          flag = true;
        }
      }
    }

    if (flag)
      this.form.get(this.nzFormGroupData.nzKey).patchValue(value);

  }
  pzSwitchFn(data: any) {
    switch (data['type']) {
      case 'changeFormValid':
        this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
        break;
      case 'openCalculate':
        if (data.datas == true) {

          this.initCalculate();
        } else {
          this.sets.datas.nzSameTableCalculate.nzUsed = false;
          this.initCalculate(false)
        }
        break;

      default:
        break;
    }
  }
  nzLinkageClosed = false;
  setValue(data) {
    console.log('setValue', data, this.sets.datas.nzValueSource)
    this.sets.datas.nzValueSource.forEach(element => {
      if (data.datas[element.key] !== undefined) {
        console.log('setValues', element, data.datas[element.key])
        this.setService.sendEvent(element.blockid, "linkagesetValue", { value: data.datas[element.key] })
      } else {
        this.setService.sendEvent(element.blockid, "linkagesetValue", { value: null })
      }
    });
  }
  switchFn(data: any) {
    console.log("Listeningdata-input", data)
    let array0 = [];
    let array1 = [], array2 = [];
    switch (data['type']) {
      case 'needCalculate':
        //通知目标积木更新值后通知回来
        this.needCalculate = data.datas;
        this.setService.events[this.needCalculate.id].emit({
          type: 'setCalculate',
          datas: {
            name: this.needCalculate.name,
            key: this.nzFormGroupData.nzKey
          }
        });
        break;
      case 'setCalculate':
        this.calculate_name_key[data.datas.name] = data.datas.key;
        break;
      case 'changeCalculateValue':
        this.calculateValue()
        break;
      case 'linkagevalue':
        if (!this.nzLinkageClosed) {
          switch (this.sets.datas.nzLinkageData.nzLinkageType) {
            case 'group':
              this.groupLinkAge(data.datas.value, '');
              break;

            default:
              this.linkageValue(data.datas.value, '')
              break;
          }
        }


        break;
      case 'linkagevaluek1':
        if (!this.nzLinkageClosed) {
          switch (this.sets.datas.nzLinkageData.nzLinkageType) {
            case 'group':
              this.groupLinkAge(data.datas.value, 'k1');
              break;

            default:
              this.linkageValue(data.datas.value, 'k1')
              break;
          }
        }


        break;
      case 'linkagevalue2':
        if (!this.nzLinkageClosed) {
          switch (this.sets.datas.nzLinkageData.nzLinkageType) {
            case 'group':
              this.groupLinkAge(data.datas.value, '2');
              break;

            default:
              this.linkageValue(data.datas.value, '2')
              break;
          }
        }

        break;
      case 'linkagevalue3':
        if (!this.nzLinkageClosed) {
          switch (this.sets.datas.nzLinkageData.nzLinkageType) {
            case 'group':
              this.groupLinkAge(data.datas.value, '3');
              break;

            default:
              this.linkageValue(data.datas.value, '3')
              break;
          }
        }

        break;
      case 'linkagesetValue':
        this.form.get(this.nzFormGroupData.nzKey).patchValue(data.datas.value)
        break;
      case 'setValues':
        // this.sets.datas.nzValueSource.forEach(element => {
        //   if (data.datas[element.key] !== undefined) {
        //     console.log('setValues', element, data.datas[element.key])
        //     this.setService.sendEvent(element.blockid, "linkagesetValue", { value: data.datas[element.key] })
        //   }
        // });
        this.setValue(data);
        break;
      case 'reset':
        let times = 0;
        try {
          if (data.datas.param2) {
            times = parseInt(data.datas.param2);
          }
        }
        catch {
        }
        if (times) {
          setTimeout(() => {

            if (times === 1) {
              this.form.get(this.nzFormGroupData.nzKey).patchValue('1')
              this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
              this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
            } else {
              if (data.datas.param1 == "true") {
                this.linkageValue("value", 4);
              } else {
                this.form.get(this.nzFormGroupData.nzKey).patchValue('')
                this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
                this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
                if (data.datas.param0 == "true") {
                  this.linkageValue("value", 4);
                }
              }
            }
          }, times);
        } else {
          if (data.datas.param1 == "true") {
            this.linkageValue("value", 4);
          } else {
            this.form.get(this.nzFormGroupData.nzKey).patchValue('')
            this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
            this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
            if (data.datas.param0 == "true") {
              this.linkageValue("value", 4);
            }
          }
        }


        break;
      case 'valid':
        this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
        this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
        break;
      case 'focus':
        if (data.datas.param0) {
          let timeValue = parseInt((data.datas.param0 + '').trim())
          if (!timeValue) timeValue = 0;
          setTimeout(() => {
            this.input.nativeElement.focus();
          }, timeValue);
        } else {
          this.input.nativeElement.focus();
        }
        console.log('ViewChild获取匹配的元素2:', this.input.nativeElement);
        break;
      case 'isable':

        console.log("isable", data.datas)
        array0 = (data.datas.param0 + "").split(",");
        array1 = (data.datas.param1 + "").split(",");
        array2 = (data.datas.param2 + "").split(",");
        if (array0.indexOf(data.datas.value) >= 0 || array2.indexOf('disable') >= 0) {
          //disable
          console.log("isable", 'disable')
          // if(array2.indexOf('disable') >= 0){
          //   this.sets.styles.nzReadOnlyLight=true;
          //   return;
          // }
          this.form.get(this.nzFormGroupData.nzKey).disable();
          if (array2.indexOf('reset') >= 0) {
            this.form.get(this.nzFormGroupData.nzKey).patchValue('')
            this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
            this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
          }
          const disableIndex = array2.indexOf('disablevalue');
          if (disableIndex >= 0 && array2[disableIndex + 1]) {
            this.form.get(this.nzFormGroupData.nzKey).patchValue(array2[disableIndex + 1])
            this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
            this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
          }

        } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 === "" || array2.indexOf('enable') >= 0) {
          // enable
          console.log("isable", 'enable')
          // if(array2.indexOf('enable') >= 0){
          //   this.sets.styles.nzReadOnlyLight=false;
          //   
          //   return;
          // }
          this.form.get(this.nzFormGroupData.nzKey).enable();
          const enableIndex = array2.indexOf('enablevalue');
          if (enableIndex >= 0 && array2[enableIndex + 1]) {
            this.form.get(this.nzFormGroupData.nzKey).patchValue(array2[enableIndex + 1])
            this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
            this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
          }
        }
        if (data.datas.param2.indexOf('linkageChange') >= 0) {
          this.nzLinkageClosed = !this.nzLinkageClosed;
        }
        break;
      case 'pageShow':

        console.log("data.datas.value", data.datas.value, data.datas.param0, data.datas.value == data.datas.param0)
        array0 = (data.datas.param0 + "").split(",");
        array1 = (data.datas.param1 + "").split(",");
        if (array0.indexOf(data.datas.value) >= 0) {
          //disable
          this.sets['styles']['nzHidden'] = true;

        } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
          // enable
          this.sets['styles']['nzHidden'] = false;
          // this.form.get(this.nzFormGroupData.nzKey).enable();
        }
        break;
      case 'linkageControl':
        array0 = (data.datas.param0 + "").split(",");
        array1 = (data.datas.param1 + "").split(",");
        if (array0.indexOf(data.datas.value) >= 0) {
          //disable
          this.sets.datas.nzLinkage.nzUsed = false;

        } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
          // enable
          this.sets.datas.nzLinkage.nzUsed = true;
          // this.form.get(this.nzFormGroupData.nzKey).enable();
        }
        break;

      default:
        break;
    }
  }



}
